import { atom } from "jotai";

export let bgmModeAtom = atom<boolean>(false);

export let themeAtom = atom<string>('default');